module.exports = false;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_library.js
// module id = 612
// module chunks = 27